import { parseISO } from 'date-fns';
import { type ReactElement } from 'react';
import { TimeElement } from '../../TimeElement/TimeElement';
import { capitalizeFirstLetter } from '../../Util';
import formatCloseRelative from '../../Util/formatCloseRelative';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import { type TrafikverketRoadCondition } from '../Sources/RoadConditionMessage';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function RoadConditionMessage(properties: TrafikverketRoadCondition, layerOptions: ClusteredMarkerLayerOptions): ReactElement {
    return (
        <PopupTemplateWrapper iconId={layerOptions.defaultIconId ?? 107} title={layerOptions.name}>
            <div className="">
                <h3>{properties.locationText}</h3>
                {properties.conditionText ? (
                    <>
                        <table>
                            <tbody>
                                {!!properties.warning?.length && (
                                    <tr>
                                        <td className="bold label-cell">Varning:</td>
                                        <td>{capitalizeFirstLetter(properties.warning.join(', ').toLowerCase())}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td className="bold label-cell">Väglag:</td>
                                    <td>
                                        {capitalizeFirstLetter(properties.conditionText)}
                                        {!!properties.conditionInfo?.length && `, ${properties.conditionInfo.join(', ').toLowerCase()}`}
                                    </td>
                                </tr>
                                {!!properties.cause?.length && (
                                    <tr>
                                        <td className="bold label-cell">Orsak:</td>
                                        <td>{capitalizeFirstLetter(properties.cause.join(', ').toLowerCase())}</td>
                                    </tr>
                                )}
                                {!!properties.measurement?.length && (
                                    <tr>
                                        <td className="bold label-cell">Åtgärd:</td>
                                        <td>{capitalizeFirstLetter(properties.measurement.join(', ').toLowerCase())}</td>
                                    </tr>
                                )}
                                <tr>
                                    <td className="bold label-cell">Giltig från:</td>
                                    <td>
                                        {properties.startTime ? (
                                            <TimeElement date={parseISO(properties.startTime)}>
                                                {capitalizeFirstLetter(formatCloseRelative(parseISO(properties.startTime)))}
                                            </TimeElement>
                                        ) : (
                                            'Ingen uppgift'
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <dl className="popup-details">
                            <dt>Källa:</dt>
                            <dd>Trafikverket</dd>
                        </dl>
                    </>
                ) : (
                    <p>Aktuell data saknas</p>
                )}
            </div>
        </PopupTemplateWrapper>
    );
}
